import 'css-chunksrc/client/scenes/costProfileEdition/costHistory/cost/dateInput/styles.scss';export default {
  "text": "_text_yv63o_1",
  "list": "_list_yv63o_9"
};